import { render } from "./AiPolicy.vue?vue&type=template&id=d7d12448&scoped=true"
import script from "./AiPolicy.vue?vue&type=script&lang=js"
export * from "./AiPolicy.vue?vue&type=script&lang=js"

import "./AiPolicy.vue?vue&type=style&index=0&id=d7d12448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d12448"]])

export default __exports__